import { createFileRoute, redirect } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { LibraryIndexPage } from "./-components/LibraryIndexPage";
import { useQuery } from "@tanstack/react-query";
import { queryClient, trpc } from "~/utils/trpc";
import { useEffect } from "react";
import { Skeleton } from "@quake/shared-ui/components/ui/skeleton";
import { hasPermission } from "~/store/usePermissionStore";

export const Route = createFileRoute("/_dashboard/$datasetSlug/library/")({
  beforeLoad: async ({ params }) => {
    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions()).catch(() => null);

    if (!hasPermission({ role: session?.user?.role, permissions: session?.user?.permissions }, "automations", "view")) {
      throw redirect({ to: "/$datasetSlug/dashboard", params: { datasetSlug: params.datasetSlug } });
    }
  },
  component: RouteComponent,
  loader: async () => {},
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Library", link: `/${datasetSlug}/library` }]);

  const { data, isLoading, refetch } = useQuery(trpc.automations.listLibraryAutomations.queryOptions());
  useEffect(() => {
    refetch();
  }, []);
  if (isLoading || !data) {
    return <LibraryIndexSkeleton />;
  }
  return <LibraryIndexPage data={data} />;
}

function LibraryIndexSkeleton() {
  return (
    <div className="p-3 sm:p-6 lg:p-8 space-y-6">
      <div className="space-y-2">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-[360px]" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 lg:gap-6 max-w-6xl w-full">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={`library-card-${index}`} className="rounded-lg border p-4 space-y-3">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-32 w-full" />
            <div className="flex gap-2">
              <Skeleton className="h-8 w-24" />
              <Skeleton className="h-8 w-24" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
